import React from 'react';
const Notibar = () =>{
    return(
        <div className="battery">
            <img 
                src="https://image.flaticon.com/icons/png/128/3103/3103460.png" 
                alt="battery"
            />
        </div>
    );
}
export default Notibar;